import core, { endpoint } from "./core";

const configs = {
  core: {
    config: core,
    endpoint,
  },
};

export default configs;
